import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useSegment from '@/composables/useSegment'
  import useCourse from '@/composables/useCourse'
  import useShopifyClient from '@/composables/useShopifyClient'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseTrialExpired',
  setup(__props) {

  const { arrowRight } = useIcons()
  const { coursePurchaseIntended, courseTrialExpiredPopupShown } = useSegment()
  const { course } = useCourse()
  const { createShopifyCheckout } = useShopifyClient()

  const shopifyCheckout = async () => {
    await coursePurchaseIntended(course.value!.id, course.value!.title, 'course_trial_expired_modal')
    await createShopifyCheckout()
  }

  onMounted(() => {
    courseTrialExpiredPopupShown(course.value!.id, course.value!.title)
  })

return { __sfc: true,arrowRight, coursePurchaseIntended, courseTrialExpiredPopupShown, course, createShopifyCheckout, shopifyCheckout, onMounted, KetchUpButton, SVGRenderer, useIcons, useSegment, useCourse, useShopifyClient }
}

})